var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinished(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5007 0.583008C15.3307 0.583008 0.583984 15.3297 0.583984 33.4997C0.583984 51.6697 15.3307 66.4163 33.5007 66.4163C51.6707 66.4163 66.4173 51.6697 66.4173 33.4997C66.4173 15.3297 51.6707 0.583008 33.5007 0.583008ZM26.9173 49.958L10.459 33.4997L15.1002 28.8584L26.9173 40.6426L51.9011 15.6588L56.5423 20.333L26.9173 49.958Z",
    fill: "#76BD1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinished);
export default __webpack_public_path__ + "static/media/finished.953c0b1671eb491d01aec73b22676bad.svg";
export { ForwardRef as ReactComponent };